<template>
  <div class="amap-wrap">
    <el-amap
      class="amap-box"
      :vid="'amap-vue'"
      id="amap-vue"
      :center="center"
      :plugin="plugin"
      :events="mapEvents"
      :amap-manager="amapManager"
      :zoom="zoom"
    >
      <el-amap-marker
        v-for="(location, index) in officeData"
        :vid="location.id"
        :key="index"
        :position="[location.lng, location.lat]"
        zIndex="100"
        content="<div class='orangeCircle'></div>"
        :events="officeMarkerEvents"
      ></el-amap-marker>
      <el-amap-marker
        v-for="(location, index) in BureauData"
        :vid="location.id"
        :key="index"
        :position="[location.lng, location.lat]"
        zIndex="101"
        content="<div class='blueCircle'></div>"
        :events="bureauMarkerEvents"
      ></el-amap-marker>
      <el-amap-info-window
        :position="officeWindow.position"
        :content="officeWindow.content"
        :visible="officeWindow.visible"
        :closeWhenClickMap="true"
        :isCustom="true"
        :autoMove="false"
      ></el-amap-info-window>
      <el-amap-info-window
        :position="bureauWindow.position"
        :content="bureauWindow.content"
        :visible="bureauWindow.visible"
        :closeWhenClickMap="true"
        :isCustom="true"
        :autoMove="false"
      ></el-amap-info-window>
      <div v-if="polyline.path.length > 0">
      <el-amap-polyline
        v-for="(item,index) in polyline.path"
        :key="index"
        :editable="polyline.editable"
        :path="polyline.path[index]"
        :events="polyline.events"
        strokeColor="#2299c5"
        strokeStyle="dashed"
        strokeOpacity=".9"
      ></el-amap-polyline>
      </div>
    </el-amap>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { AMapManager } from 'vue-amap';
import mapLine from '../mapLine.js';
let amapManager = new AMapManager();

export default {
  components: {
  },
  name: "aMap",
  data() {
    let self = this
    return {
      // zooms: [11, 18],
      amapManager: amapManager,
      center: [121.59996, 31.197646],
      mouseCenter: [],
      getMove: false,
      zoom: 10,
      mapEvents: {
        init(o) {
          o.setMapStyle('amap://styles/blue');
          o.setFeatures(['road', 'bg', 'building']);
        },
        // 鼠标滚动事件
        mousewheel: () => {
        },
        // 鼠标抬起
        mouseup: () => {
        },
        mousemove: (e) => {
          // let lng = e.lnglat.lng;
          // let lat = e.lnglat.lat;
          // self.mouseCenter = [lng, lat];
        },
        // 地图平移
        mapmove: () => {
        },
        // 地图平移结束
        moveend: () => {
          let map = this.amapManager.getMap()
          let position = [
            map.getCenter().lng,
            map.getCenter().lat
          ]
        },
        click: () => {
          self.bureauWindow.visible = false;
          self.officeWindow.visible = false;
        }
      },
      plugin: [
        {
          pName: 'AMap.Geolocation',
          events: {
            init(o) {
              // o.getCurrentPosition();
              // self.zoom = 11;
              o.options.zoomToAccuracy = true;
              let obj = new AMap.Map('getCenter');
              obj.plugin('AMap.Geolocation', function () {
                let geolocation = new AMap.Geolocation()
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete);
                AMap.event.addListener(geolocation, 'error', onError);
                function onComplete(data) {
                  // data是具体的定位信息
                  console.log(data);
                  self.center = [data.position.lng, data.position.lat]
                  var district = new AMap.DistrictSearch({
                    extensions: 'all',
                    level: 'province'
                  })
                  district.search('上海市', function (status, result) {
                    console.log(result)
                    var bounds = result.districtList[0].boundaries;
                    if (bounds) {
                      console.log(bounds);
                      bounds.forEach(e => {
                        let tempPath = [];
                        e.forEach(ele => {
                          tempPath.push([ele.lng, ele.lat]);
                        })
                        self.polyline.path.push(tempPath);
                      })
                    }
                  })
                }
                function onError(data) {
                };
              })
            }
          }
        }
      ],
      BureauData: [
        {
          id: 233,
          lng: '121.402019',
          lat: '31.170427'
        }
      ],
      officeData: [],
      polyline: {
        path: [],
        editable: false,
        events: {}
      },
      pathArr: [],
      officeMarkerEvents: {
        click: (e) => {
          console.log(e.target.Uh.vid);
          console.log(e.lnglat);
          console.log(e)
          self.officeWindow.position = [e.lnglat.lng, e.lnglat.lat];
          self.center = self.officeWindow.position;
          self.officeWindow.visible = true;
          self.officeWindow.content = "<div class='bureau-box'><div class='title-line'></div><div class='place-name'>徐汇区司法局新桥司法所</div><div class='place-detail'>警情总数：" + 46 + "</div><div class='place-detail'>处置中案件数：" + 12 + "</div><div class='place-detail'>未接受确认警情数：" + 8 + "</div><div class='place-detail'>110相关人员：" + 20 + "</div><div class='bottom-line'></div></div>";
        }
      },
      bureauMarkerEvents: {
        click: (e) => {
          console.log(e.target.Uh.vid);
          console.log(e.lnglat);
          console.log(e.pixel);
          self.bureauWindow.position = [e.lnglat.lng, e.lnglat.lat];
          self.center = self.bureauWindow.position;
          self.bureauWindow.visible = true;
          self.bureauWindow.content = "<div class='bureau-box office-box'><div class='title-line'></div><div class='place-name'>徐汇区司法局新桥司法所</div><div class='place-detail'>警情总数：" + 46 + "</div><div class='place-detail'>处置中案件数：" + 12 + "</div><div class='place-detail'>未接受确认警情数：" + 8 + "</div><div class='place-detail'>110相关人员：" + 20 + "</div><div class='bottom-line'></div></div>";
          // self.offset = e.pixel;
        }
      },
      officeWindow: {
        position: [121.59996, 31.197646],
        content: '',
        visible: false
      },
      bureauWindow: {
        position: [121.59996, 31.197646],
        content: '',
        visible: false
      }
    }
  },
  methods: {
    ...mapActions([])
  },
  watch: {
  },
  computed: {
    ...mapGetters([])
  },
  created() {
    mapLine.forEach(e => {
      let bounds = JSON.parse(e.arr).boundaries[0];
      let obj = { name: JSON.parse(e.arr).name, adcode: JSON.parse(e.arr).adcode, path: [] };
      bounds.forEach(ele => {
        let arr = [ele.lng, ele.lat];
        obj.path.push(arr);
      })
      this.pathArr.push(obj);
    })
  },
  mounted() { }
};
</script>
<style>
.orangeCircle {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(253, 140, 60, 0.3);
}
.orangeCircle::after {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(253, 140, 60);
  content: "";
}
.blueCircle {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(63, 232, 246, 0.3);
}
.blueCircle::after {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: rgb(63, 232, 246);
  content: "";
}
.bureau-box {
  position: relative;
  transform: translate(calc(50% + 30px), calc(100% - 53px));
  padding: 26px 20px 20px;
  background-color: rgba(1, 1, 1, 0.8);
}
.bureau-box::before {
  position: absolute;
  top: 45px;
  left: 0;
  transform: translateX(-100%);
  border: 15px solid transparent;
  border-right-color: rgba(1, 1, 1, 0.8);
  content: "";
}
.bureau-box .title-line {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 5px;
  background-image: linear-gradient(
    90deg,
    #fd8c3c,
    #fd8c3c 70px,
    transparent 4px,
    transparent,
    #fd8c3c 74px,
    #fd8c3c 108px,
    transparent 4px,
    transparent,
    #fd8c3c 112px,
    #fd8c3c
  );
}
.office-box.bureau-box .title-line {
  background-image: linear-gradient(
    90deg,
    #3fe8f6,
    #3fe8f6 70px,
    transparent 4px,
    transparent,
    #3fe8f6 74px,
    #3fe8f6 108px,
    transparent 4px,
    transparent,
    #3fe8f6 112px,
    #3fe8f6
  );
}
.bureau-box .place-name {
  position: relative;
  color: #fd8c3c;
  font-size: 18px;
  line-height: 18px;
  padding-left: 12px;
  margin-bottom: 14px;
}
.office-box.bureau-box .place-name {
  color: #3fe8f6;
}
.bureau-box .place-name::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 18px;
  background-color: #fd8c3c;
  content: "";
}
.office-box.bureau-box .place-name::before {
  background-color: #3fe8f6;
}
.bureau-box .place-detail {
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: left;
}
.bureau-box .bottom-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #fd8c3c;
}
.office-box.bureau-box .bottom-line {
  background-color: #3fe8f6;
}
.amap-geolocation-con {
  display: none;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/common.scss";
.amap-wrap {
  width: 100%;
  height: 100%;
}
</style>